<template>
  <div>
    <div class="partnerForm">
      <h2>{{ parseTranslation(ADD_REDIRECT_LINKS) }}:</h2>
      <form action="">
        <div>
          <label for="name">{{ parseTranslation(NAME) }}:*</label>
          <input v-model="name" type="text" id="name" name="name" />
        </div>
        <div>
          <label for="link">{{ parseTranslation(COMPLETE_LINK) }}:*</label>
          <input v-model="link" type="text" id="link" name="link" />
        </div>

        <div>
          <label for="screened">{{ parseTranslation(SCREENED) }}:*</label>
          <input v-model="screened" type="text" id="screened" name="screened" />
        </div>

        <div>
          <label for="quotafull">{{ parseTranslation(QUOTA_FULL) }}:*</label>
          <input v-model="quotafull" type="text" id="quotafull" name="quotafull" />
        </div>

        <div>
          <label for="quality_screened">{{ parseTranslation(QUALITY_SCREENED) }}:*</label>
          <input
            v-model="quality_screened"
            type="text"
            id="quality_screened"
            name="quality_screened"
          />
        </div>

        <div>
          <button @click.prevent="editPartner">
            {{ parseTranslation(SAVE) }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import * as translationAddPartner from './index.translations'

const { default: translations, ...translationKeys } = translationAddPartner

export default {
  name: 'EditPartner',
  props: ['getPartners'],
  data() {
    return {
      translations,
      ...translationKeys,
      name: '',
      link: '',
      screened: '',
      quotafull: '',
      quality_screened: '',
    }
  },
  computed: {
    pid: function() {
      return this.$route.query.pid
    },
  },
  watch: {
    pid() {
      this.loadPartner()
      this.scrollTop()
    },
  },
  methods: {
    ...mapActions(['sendMessage', 'executeSurveyAPICall']),

    async loadPartner() {
      const partner_id = this.$route.query.pid

      const partner = await this.executeSurveyAPICall({
        path: 'partner',
        queryParams: { partner_id },
      })

      if (!partner) return

      this.name = partner.partner
      this.link = partner.completed
      this.screened = partner.screened
      this.quotafull = partner.quotafull
      this.quality_screened = partner.qualityscreened
    },

    async editPartner() {
      const anyUnfilled =
        !this.name ||
        !this.link ||
        !this.screened ||
        !this.quotafull ||
        !this.quality_screened

      if (anyUnfilled)
        return this.sendMessage(this.translations[this.language][this.REQUIRED_FIELDS])

      const success = await this.executeSurveyAPICall({
        method: 'PUT',
        path: 'partner',
        payload: {
          partner_id: this.pid,
          partner: this.name,
          completed: this.link,
          screened: this.screened,
          quotafull: this.quotafull,
          qualityscreened: this.quality_screened,
        },
      })

      if (!success) return

      this.sendMessage(this.translations[this.language][this.PARTNER_UPDATED])

      this.getPartners()

      await this.$router.push({
        name: 'addpartner',
        query: { surveyId: this.$route.query.surveyId },
      })
    },

    scrollTop: function() {
      this.intervalId = setInterval(() => {
        if (window.pageYOffset === 0) {
          clearInterval(this.intervalId)
        }
        window.scroll(0, window.pageYOffset - 50)
      }, 20)
    },
    scrollListener: function(e) {
      this.visible = window.scrollY > 150
    },
  },
  created() {
    this.loadPartner()
    this.scrollTop()
  },
  mounted: function() {
    window.addEventListener('scroll', this.scrollListener)
  },
  beforeDestroy: function() {
    window.removeEventListener('scroll', this.scrollListener)
  },
}
</script>

<style lang="scss" scoped>
.partnerForm {
  margin-top: 60px;
  @include tipography(16);
  form {
    display: block;
    flex-wrap: wrap;
    div:last-of-type {
      margin-top: 10px;
      width: 100%;
      display: flex;
      justify-content: flex-end;
      button {
        background: $blue;
        border: none;
        border-radius: 3px;
        padding: 10px 20px;
        @include tipography(15);
        letter-spacing: 3px;
        text-transform: uppercase;
        font-weight: bold;
        cursor: pointer;
        &:focus {
          outline: none;
        }
      }
    }
  }
  h2 {
    @include tipography(20);
    font-weight: bold;
    margin-bottom: 30px;
  }
  input {
    width: 100%;
    display: block;
    margin: 10px 0 20px;
    @include tipography(16);
    color: $gray-5;
    background: none;
    border: 1px solid $gray-5;
    padding: 8px 10px;
    border-radius: 3px;
    &:focus {
      outline: none;
    }
  }
  .light & {
    color: $gray-6;
    h2,
    input {
      color: $gray-6;
    }
  }
}
</style>
